var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22 0.21934C7.36063 0.0788894 7.55125 0 7.75 0C7.94875 0 8.13937 0.0788894 8.28 0.21934L13.28 5.21934C13.4205 5.35997 13.4993 5.55059 13.4993 5.74934C13.4993 5.94809 13.4205 6.13871 13.28 6.27934L8.28 11.2793C8.21134 11.353 8.12854 11.4121 8.03654 11.4531C7.94454 11.4941 7.84522 11.5162 7.74452 11.5179C7.64382 11.5197 7.54379 11.5012 7.4504 11.4635C7.35701 11.4257 7.27218 11.3696 7.20096 11.2984C7.12974 11.2272 7.0736 11.1423 7.03588 11.0489C6.99816 10.9555 6.97963 10.8555 6.98141 10.7548C6.98318 10.6541 7.00523 10.5548 7.04622 10.4628C7.08721 10.3708 7.14631 10.288 7.22 10.2193L10.94 6.49934H0.75C0.551088 6.49934 0.360322 6.42032 0.21967 6.27967C0.0790175 6.13902 0 5.94825 0 5.74934C0 5.55043 0.0790175 5.35966 0.21967 5.21901C0.360322 5.07836 0.551088 4.99934 0.75 4.99934H10.94L7.22 1.27934C7.07955 1.13871 7.00066 0.948091 7.00066 0.74934C7.00066 0.550589 7.07955 0.359965 7.22 0.21934Z",
    fill: "#5070DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next_arrow.05bea902a6c2ebb58e734f560bdc5886.svg";
export { ForwardRef as ReactComponent };